import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { useTranslation as c } from "@systemeio/ui";
const n = "w-8 h-full main-transition-colors hover:bg-THEME-tertiary text-THEME-text-secondary hover:text-THEME-text-secondary", m = ({
  quantity: r,
  onIncrease: i,
  onDecrease: o,
  disabledIncreaseButton: s,
  disabledDecreaseButton: a
}) => {
  const { t: l } = c();
  return /* @__PURE__ */ t("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ e("span", { children: l("public_pages_purchase.quantity") }),
    /* @__PURE__ */ t(
      "div",
      {
        className: "border-THEME-border-tertiary flex h-8 items-center overflow-hidden rounded-md border text-[16px]",
        children: [
          /* @__PURE__ */ e(
            "button",
            {
              disabled: a,
              type: "button",
              onClick: o,
              className: n,
              children: "-"
            }
          ),
          /* @__PURE__ */ e("span", { className: "min-w-8 inline-block text-center text-[14px] font-semibold", children: r }),
          /* @__PURE__ */ e(
            "button",
            {
              disabled: s,
              type: "button",
              onClick: i,
              className: n,
              children: "+"
            }
          )
        ]
      }
    )
  ] });
};
export {
  m as QuantityPicker
};
